import { CarrierBillingAccountType } from "@redotech/cockroachdb-codegen/congodb/carrier-billing-account-type";
import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const CarrierBillingAccountSchema = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
  team: zExt.objectId().meta({ privacy: privacy.nonPii }),
  carrier: createEnum(Carriers, { enumName: "Carriers" }).meta({
    privacy: privacy.nonPii,
  }),
  accountNumber: z.string().meta({ privacy: privacy.redact }),
  accountName: z.string().meta({ privacy: privacy.nonPii }),
  country: z.string().meta({ privacy: privacy.nonPii }),
  postalCode: z.string().meta({ privacy: privacy.nonPii }),
  /** Absent on accounts created before receiver billing existed. */
  billingType: createEnum(CarrierBillingAccountType, {
    enumName: "CarrierBillingAccountType",
  })
    .nullish()
    .meta({ privacy: privacy.nonPii }),
  hidden: z.boolean().nullish().meta({ privacy: privacy.nonPii }),
  createdAt: z.date().meta({ privacy: privacy.nonPii }),
  updatedAt: z.date().meta({ privacy: privacy.nonPii }),
});

export type CarrierBillingAccount = z.infer<typeof CarrierBillingAccountSchema>;

export const CreateCarrierBillingAccountSchema =
  CarrierBillingAccountSchema.omit({
    _id: true,
    createdAt: true,
    updatedAt: true,
  });

export type CreateCarrierBillingAccount = z.infer<
  typeof CreateCarrierBillingAccountSchema
>;

/**
 * Who the carrier bills. Receiver is UPS Bill Receiver / FedEx RECIPIENT —
 * the recipient's own carrier account rather than an unrelated payer's.
 */
export function billingAccountType(account: {
  billingType?: CarrierBillingAccountType | null;
}): CarrierBillingAccountType {
  return account.billingType ?? CarrierBillingAccountType.ThirdParty;
}

export const CARRIER_BILLING_ACCOUNT_TYPE_LABEL: Record<
  CarrierBillingAccountType,
  string
> = {
  [CarrierBillingAccountType.ThirdParty]: "Third party billing",
  [CarrierBillingAccountType.Receiver]: "Receiver billing",
};
